import { UnknownAction } from "redux";
import { isStoreAction } from "../actions/Store.js";
import { StoreState } from "../types/index.js";

const reducer = (
  state: StoreState,
  action: UnknownAction,
  initialState: StoreState,
): StoreState => {
  if (!isStoreAction(action)) {
    return state;
  }

  switch (action.type) {
    case "RESET_STORE":
      return initialState;

    default:
      return state;
  }
};

export default reducer;
